import { Icon } from "web/components"
import { useDialogModal, DialogCommands } from "web/hooks/modals"

export default function BasicTile({
  children,
  isEditMode,
  handleOnHide,
  canEdit = true,
  handleTileSettings,
}) {
  const confirmDeleteTile = useDialogModal({
    title: "Remove Tile",
    prompt: "Are you sure you want to remove this tile?",
    commands: [
      { label: "Remove", variant: "primary_danger", response: true },
      DialogCommands.Cancel,
    ],
  })

  async function handleDeleteTile() {
    const result = await confirmDeleteTile()

    if (result?.response) {
      handleOnHide()
    }
  }

  return (
    <div className="group relative h-full">
      <div className="absolute right-2.5 top-2.5 z-10">
        <div className="flex flex-row gap-2.5">
          {canEdit && handleTileSettings && !isEditMode && (
            <div className="invisible cursor-pointer rounded-md bg-white p-1 shadow-altrio-1 group-hover:visible">
              <Icon
                name="cog"
                width="24px"
                height="24px"
                outline="true"
                alt="settings"
                onClick={handleTileSettings}
              />
            </div>
          )}
          {canEdit && !isEditMode && (
            <div className="invisible cursor-pointer rounded-md bg-white p-1 shadow-altrio-1 group-hover:visible">
              <Icon
                name="x-mark"
                width="24px"
                height="24px"
                outline="true"
                alt="hide"
                onClick={handleDeleteTile}
              />
            </div>
          )}
        </div>
      </div>
      <div className="ml-0 h-full overflow-hidden p-0">{children}</div>
    </div>
  )
}
